
<template>
    <div class="container border rounded p-4 mt-4">
    <form @submit.prevent="sendNewValues">
      <h2> {{$t('Настройки полей HR')}} </h2>

      <div v-for="field in hrSettingsInfoList" :key="field.code" class="mb-3">
        <div v-if="field.code === 'fileType'" class="form-group">
          <label for="fileType">{{labels.fileType}}</label>
          <v-select
            :options="options"
            :reduce="value => value.code"
            :value="newValues.fileType"
            @input="changeFileType"
            label="value"
          ></v-select>
        </div>

        <div v-else-if="field.code === 'parseTiming'" class="form-group">
          <label :for="field.code" class="form-label">{{ field.name }}</label>

          <input
            v-model="newValues[field.code]"
            @input="validateParseTiming(newValues[field.code])"
            type="text"
            class="form-control"
            :class="{'is-invalid': parseTimingError}"
          >

          <div v-if="parseTimingError" class="invalid-feedback">
            {{ parseTimingError }}
          </div>
        </div>


        <div v-else-if="field.code === 'firstLineToParse'"  class="form-group" >
          <label :for="field.code" class="form-label">{{labels[field.code]}}</label>
          <input
            v-model="newValues[field.code]"
            type="text"
            class="form-control"
            :id="field.code"
            :maxlength="field.code === 'splitterChar' && 1"
          >
        </div>
        <div v-else-if="field.code === 'splitterChar'" v-show="newValues.fileType" class="form-group" >
          <label :for="field.code" class="form-label">{{field.name}} </label>
          <input
            v-model="newValues[field.code]"
            type="text"
            class="form-control"
            :id="field.code"
            :maxlength="field.code === 'splitterChar' && 1"
          >
        </div>
        <div  v-else-if="field.code === 'filenameRegex'" class="form-group">
          <label :for="field.code" class="form-label">{{ labels.rexExpres }}</label>
          <input
            v-model="newValues[field.code]"
            @input="validateRegex"
            type="text"
            class="form-control"
            :class="{'is-invalid': regexError}"
          >
          <div v-if="regexError" class="invalid-feedback">
            {{ regexError }}
          </div>
        </div>
        <div v-else class="form-group">
          <label :for="field.code" class="form-label">{{ field.name }}</label>
          <input
            v-model="newValues[field.code]"
            type="text"
            class="form-control"
          >
        </div>
      </div>
      <button type="submit" :disabled="!!regexError || !!parseTimingError" class="btn btn-primary" >{{$t('Применить')}}</button>
    </form>
    </div>
</template>
<script>
import clearReactive from '../../../../helpers/clearReactive'
export default {
  name: "SettingsForm",
  props: {
    hrSettingsInfoList: {},
    hrFieldSettings: {}
  },
  data() {
    return {
      options: [{code: 0, value: 'Excel'}, {code: 1, value: 'Text / CSV'}],
      labels: {
        sourcePath: this.$t('Путь к источнику файлов'),
        fileType: this.$t('Тип файла'),
        firstLineToParse: this.$t('Номер первой строки данных'),
        splitterChar: this.$t('Символ-разделитель'),
        parseInterval: this.$t('Интервал в сутках между проверками'),
        rexExpres: this.$t('Регулярное выражение фильтрации имени файла'),
      },
      newValues: {
        sourcePath: null,
        fileType: null,
        firstLineToParse: null,
        splitterChar: null,
        parseInterval: null,
        regexField: null,
      },

      regexError: null,
      parseTimingError: null,
    }
  },

  mounted () {
    this.newValues = clearReactive(this.hrFieldSettings);
  },
  methods: {
    changeFileType(value) {
      this.newValues.fileType = value
    },

    validateParseTiming(value) {
      if (!value || value.trim() === '') {
        this.parseTimingError = this.$t('Поле обязательно для заполнения');
      } else {
        this.parseTimingError = null;
      }
    },


    validateRegex(event) {
      const value = event?.target?.value || ''
      try {
        new RegExp(value);
        this.regexError = null;
      } catch (e) {
        this.regexError = this.$t('Недопустимое регулярное выражение. Проверьте синтаксис');
      }
    },

    sendNewValues() {
      if (this.regexError) return;

      this.$emit('new-settings', {
        ...this.hrFieldSettings,
        ...this.newValues
      });
    },
  },





};
</script>

<style lang="scss" scoped>
</style>
